import { z } from 'zod';

export type RpeAnswer = z.output<typeof rpeAnswerSchema>;
export type RpeAnswerDTO = z.input<typeof rpeAnswerSchema>;

export const rpeAnswerSchema = z.object({
  questionId: z.string(),
  value: z.number(),
  comment: z.string().optional(),
});
